import { APP_BASE_HREF, CommonModule, DOCUMENT } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import {
  ACCOUNT_JWT_CONFIG,
  AccountJwtDataAccessModule
} from "@youm-front/account-jwt/data-access";
import { AccountDataAccessModule } from "@youm-front/account/data-access";
import { ApiDataAccessModule } from "@youm-front/api/data-access";
import { Conf2DataAccessModule } from "@youm-front/conf2/data-access";
import { ConferenceStreamDataAccessModule } from "@youm-front/conference-stream/data-access";
import { IconsModule } from "@youm-front/core";
import { DestinationsDataAccessModule } from "@youm-front/destinations/data-access";
import { DevToolsDataAccessModule } from "@youm-front/dev-tools/data-access";
import { LeftMenuFeatureLeftMenuModule } from "@youm-front/left-menu/feature/left-menu";
import {
  LOKI_CONFIG,
  LokiDataAccessModule
} from "@youm-front/loki/data-access";
import { NoticeDataAccessModule } from "@youm-front/notice/data-access";
import { NoticeFeatureNoticeModule } from "@youm-front/notice/feature/notice";
import { RoomDataAccessModule } from "@youm-front/room/data-access";
import { ROOM_STUDIO_URL } from "@youm-front/room/provider";
import { UiPopoverModule } from "@youm-front/ui-popover";
import { UiSvgModule } from "@youm-front/ui-svg";
import { ErrorHandlerModule } from "@youm-front/utils/error-handler";
import { runtimeEnvironment } from "../runtime-environments/runtime-environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { IdentityAccountOnlyGuard } from "./guards";

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25
    }),
    AccountJwtDataAccessModule,
    AccountDataAccessModule.forRoot({
      noAuthRedirectToUrl: runtimeEnvironment.noAuthRedirectToURL
    }),
    ApiDataAccessModule.forRoot({
      serverUrl: runtimeEnvironment.serverURL
    }),
    DevToolsDataAccessModule,
    ErrorHandlerModule,
    IconsModule,
    LeftMenuFeatureLeftMenuModule,
    LokiDataAccessModule,
    NoticeDataAccessModule,
    NoticeFeatureNoticeModule,
    RoomDataAccessModule,
    UiPopoverModule,
    UiSvgModule,
    Conf2DataAccessModule,
    DestinationsDataAccessModule,
    ConferenceStreamDataAccessModule,
    AppRoutingModule
  ],
  providers: [
    IdentityAccountOnlyGuard,
    {
      provide: APP_BASE_HREF,
      deps: [DOCUMENT],
      useFactory: (document: Document) => document.location.origin
    },
    {
      provide: LOKI_CONFIG,
      useValue: { container: "youm-app-front" }
    },
    {
      provide: ROOM_STUDIO_URL,
      useValue: runtimeEnvironment.studioURL
    },
    {
      provide: ACCOUNT_JWT_CONFIG,
      useValue: {
        domain: runtimeEnvironment.domain,
        name: runtimeEnvironment.tokenName
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
